//@ts-nocheck
// Normalize function to handle Turkish characters and case sensitivity
export const normalizeString = (str: any) => {
    // Ensure the input is a string
    if (typeof str !== 'string') {
        return ''; // Return an empty string or handle as needed
    }

    // Replace Turkish characters with their ASCII equivalents
    const turkishChars = {
        'ı': 'i', 'İ': 'I', 'ş': 's', 'Ş': 'S', 'ğ': 'g', 'Ğ': 'G', 
        'ü': 'u', 'Ü': 'U', 'ö': 'o', 'Ö': 'O', 'ç': 'c', 'Ç': 'C'
    };

    return str
        .toLowerCase()  // Convert to lowercase
        .replace(/[ıİşŞğĞüÜöÖçÇ]/g, char => turkishChars[char] || char);
};
